import styled from 'styled-components';

const statuses = {
  completed: {
    bgColor: '#16a34a',
    color: '#dcfce7',
    label: 'Completed'
  },
  failed: {
    bgColor: '#dc2626',
    color: '#fee2e2',
    label: 'Failed'
  },
  'in progress': {
    bgColor: '#2563eb',
    color: '#dbeafe',
    label: 'In progress'
  }
} as const;

type StatusKey = keyof typeof statuses;
type StatusTagProps = {
  status: StatusKey;
};

export default function StatusTag({ status }: StatusTagProps) {
  return (
    <Wrapper
      style={{
        backgroundColor: statuses[status].bgColor,
        color: statuses[status].color
      }}
    >
      {statuses[status].label}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 5px 25px;
  font-size: 14px;
  line-height: 20px;
  border-radius: 6px;
`;
